<ux-messages-view-admin
	[messages]="messages$ | async"
	[currentTreatment]="currentTreatment$ | async"
/>
